import * as React from 'react'
import { buildGetString } from './stringUtils'

type DPContext = {
  getString: ReturnType<typeof buildGetString>
}

const DpWidgetContext = React.createContext<DPContext>(null)
export { DpWidgetContext }